import styled from "@emotion/styled"
import HeroText from "components/Hero/HeroText"

const HeroFormText = styled(HeroText)`
  margin-bottom: 40px !important;
`

export default HeroFormText
